import axios, { AxiosPromise } from 'axios';

const host: string =
  window.topContext && window.topContext.hasOwnProperty('config')
    ? window.topContext.config.getEndpointConfig().apiAwsHost.substr(8)
    : 'api.webplatform-hybridapps-staging-01.topdanmark.cloud';

export const call = (config: any, method?: string): AxiosPromise => {
  return axios(config);
};

export const get = (url: string, headers: any): AxiosPromise => {
  const defaultHeaders = {
    'Content-Type': 'application/json; charset=utf-8',
    'x-top-appname': 'onsa-personal-injury'
  };

  return axios({
    method: 'get',
    url: url,
    headers: headers || defaultHeaders
  });
};

export const post = (url: string, data: any, headers: any): AxiosPromise => {
  const defaultHeaders = {
    'Content-Type': 'application/json;charset: utf-8',
    'x-top-host': host,
    'x-top-port': '80',
    'x-top-brand': 'TD',
    'x-top-appname': 'onsa-personal-injury'
  };
  return axios({
    method: 'post',
    url: url,
    headers: headers || defaultHeaders,
    data: data
  });
};

export const put = (url: string, data: any, headers: any): AxiosPromise => {
  const defaultHeaders = {
    'Content-Type': 'application/json;charset: utf-8',
    'x-top-host': host,
    'x-top-port': '80',
    'x-top-brand': 'TD',
    'x-top-appname': 'onsa-personal-injury'
  };
  return axios({
    method: 'put',
    url: url,
    headers: headers || defaultHeaders,
    data: data
  });
};

export const remove = (url: string, headers: any, data?: any): AxiosPromise => {
  const defaultHeaders = {
    'Content-Type': 'application/json;charset: utf-8',
    'x-top-host': host,
    'x-top-port': '80',
    'x-top-brand': 'TD',
    'x-top-appname': 'onsa-personal-injury'
  };
  return axios({
    method: 'delete',
    url: url,
    headers: headers || defaultHeaders,
    data: data
  });
};
